<div class="input-group" style="width: 300px;">
    <span class="input-group-text">
        <i class="fas fa-search"></i>
    </span>
    <input [(ngModel)]="term" (ngModelChange)="search()" type="text" class="form-control"
        placeholder="Search suppliers..." />
    @if (term) {
    <button class="btn btn-outline-secondary" type="button" (click)="clearTerm()" title="Clear search">
        <i class="fas fa-times"></i>
    </button>
    }
</div>
